module.exports = __webpack_public_path__ + "fontawesome-webfont.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/font-awesome-4.7.0/fonts/fontawesome-webfont.eot?v=4.7.0
// module id = 962
// module chunks = 24